import { initializeApp } from "firebase/app";
import { getRemoteConfig } from "firebase/remote-config";
import { getAnalytics } from "firebase/analytics";
import { logEvent } from "firebase/analytics";
import useCashRegisterStore from "@/stores/cash-register";
import { fetchAndActivate } from "firebase/remote-config";

const productionConfig = {
  apiKey: "AIzaSyCDRX6wLBhQ7hc60VKQN9xdDv0o6_y4DuQ",
  authDomain: "valk-togo-kassa.firebaseapp.com",
  projectId: "valk-togo-kassa",
  storageBucket: "valk-togo-kassa.appspot.com",
  messagingSenderId: "493548251137",
  appId: "1:493548251137:web:11b275763468544ed5b800",
};

const stagingConfig = {
  apiKey: "AIzaSyB_L9SixZbL7cqBvE88Nv8_XUKGVywOF_0",
  authDomain: "valktogo-kassa---staging.firebaseapp.com",
  projectId: "valktogo-kassa---staging",
  storageBucket: "valktogo-kassa---staging.appspot.com",
  messagingSenderId: "211529765324",
  appId: "1:211529765324:web:fb43a25feb4e0dfdc94d69",
};

const firebaseConfig =
  import.meta.env.MODE === "production" && import.meta.env.VITE_PREVIEW_RELEASE === "false"
    ? productionConfig
    : stagingConfig;

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

const remoteConfig = getRemoteConfig(app);
remoteConfig.settings.minimumFetchIntervalMillis = 5 * 60 * 1000; // 5min;
remoteConfig.defaultConfig = {
  isSnowing: false,
};
fetchAndActivate(remoteConfig);

const logFirebaseEvent = (message: string, params: { [key: string]: any } = {}) => {
  const { id, name } = useCashRegisterStore.getState().current?.shop.property || {};

  logEvent(analytics, message, {
    property_id: id,
    property_name: name,
    ...params,
  });
};

export { logFirebaseEvent, remoteConfig };
